import SecureLS from 'secure-ls'

export const UNCONFIRMED_STATUS_ID = 1;
export const CONFIRMED_STATUS_ID = 2;
export const ARRIVED_STATUS_ID = 3;
export const ATTENDING_STATUS_ID = 4;
export const ATTENDED_STATUS_ID = 5;
export const CANCELLED_STATUS_ID = 6;

export const getStatusColor = (statusId) => {
    switch(statusId){
        case UNCONFIRMED_STATUS_ID:
            return 'pink'
        case CONFIRMED_STATUS_ID:
            return 'orange darken-1'
        case ARRIVED_STATUS_ID:
            return 'teal'
        case ATTENDING_STATUS_ID:
            return 'blue'
        case CANCELLED_STATUS_ID:
            return 'error'
        default:
            return 'green'
    }
}

export const getStatusIcon = (statusId) => {
    switch(statusId){
        case 1:
            return 'question_mark'
        case 2:
            return 'thumb_up'
        case 3:
            return 'hourglass_empty'
        case 4:
            return 'supervisor_account'
        case 6:
            return 'event_busy'
        default:
            return 'done'
    }
}

export const addEventToHistory = (event) => {

    const ls = new SecureLS

    var currentStack = ls.get('eventHistory')
    if(!currentStack) currentStack = []


}

export const getCompanionLabel = (relationship) => {

    const labels = {
        'fiancee': 'Pareja',
        'friend': 'Amigo(a)',
        'parent': 'Padre / Madre',
        'grandparent': 'Abuelo(a)',
        'other': 'Acompañante'
    }

    return labels[relationship] || null

}

export const getSubTypeLabel = (subType) => {

    const labels = {
        'individual': 'Individual',
        'two': 'Parejas',
        'group': 'Grupal',
    }

    return labels[subType] || 'Individual'

}

export const getSubTypeIcon = (subType) => {

    const labels = {
        'individual': 'fa-user',
        'two': 'fa-user-friends',
        'group': 'fa-users',
    }

    return labels[subType] || 'fa-user'

}

